module.exports = __webpack_public_path__ + "de0ec3da891e804497ad86c78462f956.pdf";